import { createSlice } from '@reduxjs/toolkit';
import { CourseCodeFormViewModel } from '../../types/CourseCodeFormViewModel';
import { isEmptyObject } from '../../utilities/helperUtilities';
import type { RootState } from '../store';
import {
  fetchCourseCodeFormViewModel,
} from '../thunks/commonThunks';

interface CommonState {
  loadingFormViewModel: boolean;
  formViewModel: CourseCodeFormViewModel;
}

export const defaultFormState: CourseCodeFormViewModel = {
  availableCarnegieUnitCreditOptions: [],
  workBasedLearningOpportunityTypeOptions: [],
  sequenceOfCourseOptions: [],
  cipCodeOptions: [],
  careerClusterOptions: [],
  certificateRequiredOptions: [],
  specificEndorsementOptions: [],
  courseFundingProgramOptions: [],
  courseLevelCharacteristicOptions: [],
  scedCourseLevelOptions: [],
  scedCourseSubjectAreaOptions: [],
  endOfCourseAssessmentRequirementOptions: [],
  scedGradeSpanOptions: [],
  courseBeginDate: '',
  courseEndDate: '',
};

export const initialState: CommonState = {
    loadingFormViewModel: false,
    formViewModel: defaultFormState
};

export const commonSlice = createSlice({
  name: 'common',
   initialState,
   reducers: {},
  extraReducers: (builder) => {
    // fetchCourseCodeFormViewModel
    builder.addCase(fetchCourseCodeFormViewModel.pending, (state) => {
      state.formViewModel = defaultFormState;
      state.loadingFormViewModel = true;
    });
    builder.addCase(fetchCourseCodeFormViewModel.fulfilled, (state, action) => {
      if (!isEmptyObject(action.payload)) {
        state.formViewModel = action.payload;
      }
      state.loadingFormViewModel = false;
    });
    builder.addCase(fetchCourseCodeFormViewModel.rejected, (state, action) => {
      if (!action.meta.aborted) {
        state.loadingFormViewModel = false;
      }
    });
  },
});


// formViewModel
export const selectCourseCodeLoadingFormViewModel = (
  state: RootState
): boolean => state.courseCode.loadingFormViewModel;
export const selectCourseCodeFormViewModel = (
  state: RootState
): CourseCodeFormViewModel => state.courseCode.formViewModel;


export default commonSlice.reducer;
